export const SECTION_LIBRARY_TYPES_URL = "studio/section_library/types";
export const SECTION_LIBRARY_SECTIONS_URL = "studio/section_library/sections";
export const SECTION_LIBRARY_TREE_URL = variantKey => `studio/section_library/sections/${encodeURIComponent(variantKey)}/tree`;
// The sections endpoint caps a page at 200; no section type has that many templates.
export const SECTION_LIBRARY_PAGE_SIZE = 200;

export const LIBRARY_PAGE_SEGMENT = "library";
export const LIBRARY_ICON = "material-symbols:auto-awesome-mosaic-outline";

export const DEVICE_DESKTOP = "desktop";
export const DEVICE_PHONE = "phone";
export const LIBRARY_DEVICE_TABS = [
  { id: DEVICE_DESKTOP, label: "Desktop" },
  { id: DEVICE_PHONE, label: "Phone" },
];
export const LIBRARY_STYLE_OPTIONS = [
  { value: "", name: "Any style" },
  { value: "minimal", name: "Minimal" },
  { value: "editorial", name: "Editorial" },
  { value: "bold", name: "Bold" },
  { value: "playful", name: "Playful" },
  { value: "corporate", name: "Corporate" },
  { value: "technical", name: "Technical" },
];
export const LIBRARY_DENSITY_OPTIONS = [
  { value: "", name: "Any spacing" },
  { value: "airy", name: "Airy" },
  { value: "standard", name: "Standard" },
  { value: "dense", name: "Dense" },
];
export const LIBRARY_MODE_TABS = [
  { id: "light-mode", label: "Light" },
  { id: "dark-mode", label: "Dark" },
];

export const SECTION_TYPE_ICONS = {
  "navbar": "material-symbols:menu",
  "hero": "material-symbols:web-asset",
  "logo-cloud": "material-symbols:verified-outline",
  "features": "material-symbols:grid-view-outline",
  "bento": "material-symbols:dashboard-outline",
  "stats": "material-symbols:monitoring",
  "steps": "material-symbols:format-list-numbered",
  "testimonials": "material-symbols:format-quote-outline",
  "pricing": "material-symbols:sell-outline",
  "comparison": "material-symbols:table-outline",
  "faq": "material-symbols:help-outline",
  "cta": "material-symbols:ads-click",
  "team": "material-symbols:groups-outline",
  "blog-list": "material-symbols:article-outline",
  "content": "material-symbols:notes",
  "gallery": "material-symbols:photo-library-outline",
  "video": "material-symbols:smart-display-outline",
  "event-schedule": "material-symbols:event-outline",
  "product-grid": "material-symbols:storefront-outline",
  "careers": "material-symbols:work-outline",
  "integrations": "material-symbols:extension-outline",
  "banner": "material-symbols:campaign-outline",
  "footer": "material-symbols:bottom-panel-close-outline",
};
export const SECTION_TYPE_FALLBACK_ICON = "material-symbols:view-agenda-outline";
